import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
// OBTIENER LISTADO DE BANCOS
export const getBancosList = async(Token) => {
    const result = await PublicInterceptor('Global/Bancos', 'GET', {}, Token)
    return result;

}
